<script lang="ts">
import {defineComponent} from 'vue'
import IPAddressTypeBadge from './IPAddressTypeBadge.vue'
import DBEditor from './db-editor/APIObjectDBEditor.vue'
import transactionutil from '../util/transactionutil'
import GenIPAddrService from '../api-services.gen/dns.ip_addr'
import ReserveIPAddrDBEditor from '@/db-editors/ReserveIPAddr.vue'

export default defineComponent({
  name: 'ReservedAddressesCard',
  components: {ReserveIPAddrDBEditor, DBEditor, IPAddressTypeBadge},
  props: {
    loaded: null,
    reserved_addrs: null,
    subnets: null,
  },
  data() {
    return {
      per_page: 50,
      current_page: {},
      db_editor_function: 'create',
      db_editor_old_data: {},
      db_editor_presets: {},
      object_title: '',
      current_cidr: null
    }
  },
  computed: {
    reserved_addrs_list_fields() {
      return [
        {
          label: this.$tc('system.address', 2),
          key: 'value',
          sortable: false // TODO: Sort function
        }
      ]
    },
    reserved_address_grouped_by_subnet() {
      const result = {}
      this.reserved_addrs.forEach(reservedAddress => {
        const subnet = reservedAddress.cidr
        if (subnet in result) {
          result[subnet].push(reservedAddress)
        } else {
          result[subnet] = [reservedAddress]
        }
      })
      return result
    }
  },
  methods: {
    onCreateIPAddressReservation(cidr) {
      this.current_cidr = cidr
      this.$root.$emit('bv::show::modal', 'create_ip_addr_range')
    },
    onEditIPAddressReservation(ipAddress) {
      this.db_editor_old_data = ipAddress
      this.db_editor_function = 'update'
      this.db_editor_presets = ipAddress
      this.object_title = ipAddress.value
      this.$nextTick(() => {
        this.$root.$emit('bv::show::modal', 'create_ip_addr')
      })
    },
    onDeleteIPAddressReservation(item) {
      const ipaddr_delete_params = GenIPAddrService.deleteParamsList()
      const ta = transactionutil.generateDeleteElement('dns.ip_addr', ipaddr_delete_params, item, this.$t('system.ip_address') + ' ' + item.value)
      this.$store.commit('addTransactionElement', ta)
      this.$emit('commited', ta)
      if (!this.isMobile() && !this.$store.state.show_sidebar_right) {
        this.$store.commit('showSidebarRight', true)
      }
    }
  }
})

</script>

<template>
  <div>
    <b-table v-for="[subnet, reserved_addr] in Object.entries(reserved_address_grouped_by_subnet)" :key="subnet"
             :items="reserved_addr" :fields="reserved_addrs_list_fields"
             :current-page="current_page['_reserved']">
      <template v-slot:cell(value)="data">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center flex-wrap">
            <code class="mr-2">{{ data.item.value }}</code>
            <b-badge v-if="data.item.is_dhcp" class="mr-1">{{ $t('system.dhcp') }}</b-badge>
            <IPAddressTypeBadge :subnets="subnets" :record_address="data.item.value" class="mr-1"/>
          </div>

          <b-button-group class="ml-2">
            <b-button variant="outline-primary" @click="onEditIPAddressReservation(data.item)">
              <netvs-icon icon="edit"></netvs-icon>
            </b-button>
            <b-button variant="outline-danger" @click="onDeleteIPAddressReservation(data.item)">
              <netvs-icon icon="delete"></netvs-icon>
            </b-button>
          </b-button-group>
        </div>
      </template>
      <template v-slot:head(value)="data" style="display: flex; justify-content: space-between;">
        <span style="margin-top: 3px">{{ data.label }} ({{ subnet }})</span>
        <b-button variant="outline-success" :id="'button_create_ip_addr'" @click="onCreateIPAddressReservation(subnet)"
                  style="float:right">
          <netvs-icon icon="create"></netvs-icon>
        </b-button>
      </template>
    </b-table>
    <b-pagination v-if="loaded && reserved_addrs.length > per_page" :per_page="per_page"
                  align="center" v-model="current_page['_reserved']"
                  :total-rows="reserved_addrs.length"></b-pagination>

    <ReserveIPAddrDBEditor :cidr="current_cidr" modal_id="create_ip_addr_range"/>
    <DBEditor modal_id="create_ip_addr"
              :object_function=db_editor_function object_fq_name="dns.ip_addr" :old_data="db_editor_old_data"
              :non_optionals_order="['value', 'is_dhcp', 'is_reserved']" :presets="db_editor_presets"
              :object_title="object_title">
    </DBEditor>
  </div>
</template>

<style scoped>

</style>
